import React from "react";

const LoadingSpinner = ({ message = "Finding tasks for Gert to do..." }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          width: "40px",
          height: "40px",
          border: "4px solid #e6e9ef",
          borderTop: "4px solid #0073ea",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
          marginBottom: "16px",
        }}
      />
      <div
        style={{
          fontSize: "14px",
          color: "#676879",
          fontWeight: 500,
        }}
      >
        {message}
      </div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingSpinner;

